export default (state, { payload: { productId } }) => ({
  ...state,
  productId: parseInt(productId)
});
